import { FIND_USER } from "../../routes";
import { IFindUserInformation } from "../../../types/common.interface";
import customAxios from "../../customAxios";
import utils from "../../../utils";

async function findParent(props: IFindUserInformation) {
  var thisUrl = FIND_USER + "?";
  if (props.page) thisUrl += `page=${props.page}`;
  if (props.limit) thisUrl += `&limit=${props.limit}`;

  const populateFields =
    "blocks gender parentInformation.city parentInformation.province parentInformation.neighborhood parentInformation.isNew parentInformation.isArchived parentInformation.town parent financial";

  thisUrl += `&populate=${populateFields}`;

  let body: any = {
    query: {
      userTypes: {
        $in: ["PASSENGER"],
      },
    },
  };

  // ?? ---------------------------------------------------------------------------------------------------------------------
  // ?? =====================================================================================================================
  // ??                                            Searching For SuperAgent
  // ?? =====================================================================================================================
  // ?? ---------------------------------------------------------------------------------------------------------------------

  if (props?.search?.value) {
    body = {
      query: {
        ...body.query,
        [String(props.search.base)]: utils.convertNumbers2English(
          props.search.value
        ),
      },
    };
  }

  // ?? ---------------------------------------------------------------------------------------------------------------------
  // ?? =====================================================================================================================
  // ??                                                    Filtering For SuperAgent
  // ?? =====================================================================================================================
  // ?? ---------------------------------------------------------------------------------------------------------------------

  if (props?.filters) {
    const { province, city, gender } = props.filters;
    body = {
      query: {
        ...body.query,
        "parentInformation.city": city?._id,
        "parentInformation.province": province?._id,
        "parentInformation.isArchived": props?.filters?.isArchive,
        gender: gender?.value,
      },
    };

    // if (province) query({ target: "province", value: province?._id });
    // if (city) query({ target: "city", value: city?._id });
    // if (superAgent) query({ target: "superAgent", value: superAgent?._id });
  }

  // !! ---------------------------------------------------------------------------------------------------------------------
  // !! =====================================================================================================================
  // !!                                            Try Catch For SuperAgent
  // !! =====================================================================================================================
  // !! ---------------------------------------------------------------------------------------------------------------------

  // ?? Academic year (سال تحصیلی) scope. Set last, and on the body root rather than inside `query`, because the
  // ?? search and filter branches above rebuild `body` wholesale and would otherwise drop it.
  if (props.academicYear) body.academicYear = props.academicYear;

  try {
    return (await customAxios.post(thisUrl, body)).data;
  } catch (error: any) {
    console.error({ GET_ALL_COMPANY: error });
  }
}

export default findParent;
